// extracted by mini-css-extract-plugin
module.exports = {"root":"_071ea6"};